import React, { useState } from "react";
import { Link, NavLink } from "react-router-dom";

const NavbarMenu = ({ data }) => {
  const [openSubmenu, setOpenSubmenu] = useState(false);

  return (
    <li
      onMouseEnter={() => setOpenSubmenu(true)}
      onMouseLeave={() => setOpenSubmenu(false)}
      className="z-30 group"
    >
      <NavLink
        to={data.link}
        className={({ isActive }) =>
          `flex relative ${isActive && "text-yellow-700"} ${
            data.name === "ثبت نام وبینار" && "text-yellow-700 animate-pulse"
          } hover:text-yellow-700 items-center text-sm justify-center gap-2 py-2 px-3 w-fit text-gray-100 group-hover:text-slate-500 transition-all duration-300`
        }
      >
        {data.name === "ثبت نام وبینار" ? <span className="size-2 block rounded-full bg-yellow-700"></span> : ""}
        <span>{data.name}</span>

        {data.subMenu && (
          <svg
            xmlns="http://www.w3.org/2000/svg"
            fill="none"
            viewBox="0 0 24 24"
            strokeWidth="1.5"
            stroke="currentColor"
            className="w-4 h-4 -mr-1"
          >
            <path
              strokeLinecap="round"
              strokeLinejoin="round"
              d="M19.5 8.25l-7.5 7.5-7.5-7.5"
            />
          </svg>
        )}
      </NavLink>

      {data.subMenu && (
        <div
          className={`navbar-submenu ${
            openSubmenu ? "open" : "invisible opacity-0 translate-y-4"
          } absolute flex justify-center items-center w-full h-96 bg-white shadow-lg mt-[6px] left-2/4 -translate-x-2/4 transition-all duration-300`}
        >
          <h1>{data.subMenu}</h1>
        </div>
      )}
    </li>
  );
};

export default NavbarMenu;
